import React from 'react';
const Loder = ()=>{
    return <div>Loading...</div>
}

export default Loder;